import Loader from 'components/assets/icons/Loader'
import style from './Loading.module.scss'

const Loading = ({ height }) => {

  return (
    <div className={style.container} style={{ height }}>
      <Loader />
    </div>
  )
}
export default Loading